var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPline20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1213",
    x: 9.375,
    y: 0.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 32 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7517 3.84027C15.613 3.27088 14.3096 3.125 13.75 3.125V1.875C14.4404 1.875 15.9495 2.04162 17.3108 2.72223C18.6988 3.41623 20 4.69075 20 6.875C20 9.05925 18.6988 10.3338 17.3108 11.0278C15.9495 11.7084 14.4404 11.875 13.75 11.875V10.625C14.3096 10.625 15.613 10.4791 16.7517 9.90973C17.8637 9.35373 18.75 8.44075 18.75 6.875C18.75 5.30925 17.8637 4.39627 16.7517 3.84027Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 33 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42834 15.7141L9.67834 11.9641L10.3215 13.036L4.07146 16.786L3.42834 15.7141Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1215",
    x: 0.625,
    y: 15.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1214",
    x: 9.375,
    y: 9.375,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPline20);
export default __webpack_public_path__ + "static/media/pline_20.05930a6c56086bb8d0e9d437232dce27.svg";
export { ForwardRef as ReactComponent };